import React, { useMemo, useState } from "react";
import { Alert, Table, Layout, Tabs, Input } from "antd";
import useUserManagement from "./logic/useUserManagement";
import ModalEditUser from "./ModalEditUser/ModalEditUser";
import PendingRequests from "./components/PendingRequests/PendingRequests";

import "./UserManagement.scss";
import RoleManagement from "./components/RoleManagement/RoleManagement";

const UserManagement = () => {
  const {
    users,
    isFetching,
    error,
    columns,
    onChange,
    handleSearchChange,
    rowClassName,
    selectedUser,
    openEditModalUser,
    setOpenEditModalUser,
  } = useUserManagement();

  const [name, setName] = useState("User List");

  const onChangeHeaderName = (key) => {
    switch (key) {
      case "1":
        setName("User List");
        break;
      case "2":
        setName("Pending Requests");
        break;
      default:
        setName("User List");
    }
  };

  const items = useMemo(
    () => [
      {
        key: "1",
        label: `User Manangement`,
        children: (
          <div className="role-container">
            <Input.Search
              placeholder="Search..."
              onChange={handleSearchChange}
              style={{ width: "300px" }}
              className="search-input"
            />
            <div className="user-content-container">
              {error ? (
                <Alert message="An error has occurred" type="error" showIcon />
              ) : (
                <>
                  <Table
                    columns={users.data.length ? columns : []}
                    dataSource={users.data}
                    onChange={onChange}
                    loading={isFetching}
                    pagination={{
                      pageSize: users.meta?.take,
                      total: users.meta?.itemCount,
                      current: users.meta?.page,
                    }}
                    rowClassName={rowClassName}
                  />
                  <ModalEditUser
                    openEditModalUser={openEditModalUser}
                    setOpenEditModalUser={setOpenEditModalUser}
                    userData={selectedUser}
                  />
                </>
              )}
            </div>
          </div>
        ),
      },
      {
        key: "2",
        label: `Role management`,
        children: (
          <div>
            <RoleManagement />
          </div>
        ),
        },
          {
            key: "3",
            label: `Pending Requests`,
            children: (
              <div>
                <PendingRequests />
              </div>
            ),
          },
    ],
    [users, isFetching, error, columns, onChange, handleSearchChange, rowClassName, selectedUser, openEditModalUser, setOpenEditModalUser]
  );

  return (
    <Layout pagename={name}>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChangeHeaderName}
        className="custom-tabs"
        destroyInactiveTabPane={true}
      />
    </Layout>
  );
};

export default UserManagement;
